// extracted by mini-css-extract-plugin
export default {"shape":"Stats_shape__9ZaQV","item":"Stats_item__+HR-j","gridItem":"Stats_gridItem__oNznO"};